import { render } from "./Loader.vue?vue&type=template&id=130efb44&scoped=true"
const script = {}

import "./Loader.vue?vue&type=style&index=0&id=130efb44&scoped=true&lang=css"

import exportComponent from "C:\\Users\\Hardcore\\Documents\\LEARNING\\VUE PROJECT\\altschool\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-130efb44"]])

export default __exports__